import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const quotePartMoveToSchema = (maxLineNumber: number) =>
  yup.object().shape({
    lineNumber: numberSchemaWithTransform()
      .label(t('labelLineNumber'))
      .nullable()
      .min(0)
      .max(maxLineNumber)
      .required(),
  });
